import PropTypes from 'prop-types'
import { compose, setPropTypes } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { selectCustomerProfile } from 'src/store/selectors/customerProfile'
import { selectSponsorship } from 'src/store/selectors/sponsorship'

const propTypes = {
  disableCospo: PropTypes.bool
}

const SingleContainer = compose(
  setPropTypes(propTypes),
  connect((state, { disableCospo }) => {
    const customerProfile = selectCustomerProfile(state) || {}
    return {
      customerProfile,
      sponsor: (!disableCospo && selectSponsorship(state)) || {}
    }
  }),
  injectIntl
)

export default SingleContainer
